window.PedidoCliente = Backbone.Model.extend({

});

window.PedidosClientes = Backbone.Collection.extend({
    model: PedidoCliente
});